import { useRouter } from 'vue-router'
import { LocalStorage } from 'quasar'

import type { RouteLocationRaw } from 'vue-router'

export const useAuthHelpers = () => {
  const router = useRouter()
  // REDIRECT
  /**
   * Redirects the user to a specified route or a backup route.
   * If a redirect route is stored in the local storage, the user will be redirected to that route.
   * Otherwise, the user will be redirected to the backup route.
   * @param backupRedirect The backup route to redirect the user to if no redirect route is stored.
   */
  const redirect = (backupRedirect: RouteLocationRaw) => {
    const redirect = LocalStorage.getItem('redirect')
    if (redirect) {
      void router.push(redirect as RouteLocationRaw)

      LocalStorage.remove('redirect')
    } else {
      void router.push(backupRedirect)
    }
  }

  return { redirect }
}
